import { render, staticRenderFns } from "./datasetComparism.vue?vue&type=template&id=15520d18&"
import script from "./datasetComparism.vue?vue&type=script&lang=js&"
export * from "./datasetComparism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports